import { jsx as _jsx } from "react/jsx-runtime";
import { useAuth, usePasswordLoginMutation } from "@madmedical/store";
import { useEffect } from "react";
import { useNavigate } from "@madmedical/routing";
import { ApiFormWrapper } from "@madmedical/form";
import { CallCenterLogin } from "@madmedical/ui";
const Login = () => {
    const { isTokenAvailable } = useAuth();
    const [login] = usePasswordLoginMutation();
    const navigate = useNavigate();
    useEffect(() => {
        if (isTokenAvailable) {
            navigate("/");
        }
    }, [isTokenAvailable, navigate]);
    if (isTokenAvailable) {
        return null;
    }
    return (_jsx(ApiFormWrapper, Object.assign({ defaultValues: { email: "", password: "" }, mutation: login, resetOnSuccess: true }, { children: ({ submitForm }) => _jsx(CallCenterLogin, { onSubmit: submitForm }) })));
};
export default Login;
